'use client'
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'

import { methods } from '@/shared/api/constants'

export type Params = {
  code: string
}

export type ConfirmEmailResponse = {
  user: {
    id: number
    email: string
    firstname: string
    lastname: string | null
  }
  message: string
}

const confirmEmail = async (params: Params) => {
  const res = await api.json<ConfirmEmailResponse>(API_END_POINTS.auth.confirmEmail({ code: params.code }), {
    method: methods.post,
  })

  return res
}

export default confirmEmail
